import { Currency } from '../brand/brand';

export const isValidCurrencyCode = (code: string) => {
  return code in Currency;
};
